export default __webpack_public_path__ + "static/media/Background_00056.56c9bf07.png";